import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewEncapsulation
} from "@angular/core";
import {Trial} from "../../model/trial";
import {Cohort} from "../../model/cohort";


@Component({
  selector: 'gen-toc-viewer',
  templateUrl: './toc-viewer.component.html',
  styleUrls: ['./toc-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class TocViewerComponent implements OnChanges {

  @Input() trial: Trial;
  @Output() selectTop = new EventEmitter();
  @Output() selectCohort = new EventEmitter<Cohort>();

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  onSelectTop() {
    this.selectTop.emit();
  }

  onSelectCohort(cohort: Cohort) {
    this.selectCohort.emit(cohort);
  }
}
